/**
 * Shop by Sound — recommendation quiz
 */
(function () {
  'use strict';

  function bindQuiz() {
    document.querySelectorAll('[data-sbs-quiz]').forEach((quiz) => {
      if (quiz.dataset.sbsBound === '1') return;
      quiz.dataset.sbsBound = '1';

      const titleEl = quiz.querySelector('[data-sbs-quiz-title]');
      const textEl = quiz.querySelector('[data-sbs-quiz-text]');
      const moreLink = quiz.querySelector('.sbs-quiz__actions .sbs-btn--primary');
      const productCards = quiz.querySelectorAll('[data-sbs-quiz-product]');
      const mapEl = quiz.querySelector('[data-sbs-quiz-map]');

      const readAnswer = (group) => {
        const active = quiz.querySelector(`[data-sbs-quiz-group="${group}"].is-active`);
        return active ? active.getAttribute('data-sbs-quiz-opt') || '' : '';
      };

      const answers = {
        sound: readAnswer('sound') || 'creamy',
        feel: readAnswer('feel') || 'linear',
      };

      let map = {
        default: {
          title: 'Brown Switch',
          text: "You're still exploring — <strong>Brown is a versatile place to start</strong>. Hear it, then compare a few boards:",
        },
      };

      if (mapEl) {
        try {
          map = Object.assign({}, map, JSON.parse(mapEl.textContent || '{}'));
        } catch (e) {
          // ignore bad JSON
        }
      }

      // Option values use "unsure"; merchants often type "Not sure yet" in matches.
      const normalizeMatchToken = (s) =>
        String(s || '')
          .toLowerCase()
          .trim()
          .replace(/not\s*sure\s*yet/g, 'unsure');

      const parseMatches = (raw) =>
        String(raw || 'default')
          .split(',')
          .map((s) => normalizeMatchToken(s))
          .filter(Boolean);

      const resolveKey = () => {
        const sound = answers.sound || 'creamy';
        const feel = answers.feel || 'linear';
        return `${sound}|${feel}`;
      };

      const filterProducts = (key) => {
        if (!productCards.length) return;
        const keyLower = normalizeMatchToken(key || 'default');
        let visible = 0;

        productCards.forEach((card) => {
          const matches = parseMatches(card.getAttribute('data-matches') || 'default');
          const show = matches.includes(keyLower) || (keyLower === 'default' && matches.includes('default'));
          card.classList.toggle('is-hidden', !show);
          if (show) {
            card.removeAttribute('hidden');
            visible += 1;
          } else {
            card.setAttribute('hidden', '');
          }
        });

        if (visible === 0 && keyLower !== 'default') {
          productCards.forEach((card) => {
            const matches = parseMatches(card.getAttribute('data-matches') || 'default');
            const show = matches.includes('default');
            card.classList.toggle('is-hidden', !show);
            if (show) card.removeAttribute('hidden');
            else card.setAttribute('hidden', '');
          });
        }
      };

      const update = () => {
        const key = resolveKey();
        const result = map[key] || map.default;

        if (titleEl) titleEl.textContent = result.title || '';
        if (textEl) {
          const html = result.text || '';
          textEl.innerHTML = html.indexOf('<p') === 0 ? html : `<p>${html}</p>`;
        }
        if (moreLink) {
          moreLink.setAttribute(
            'href',
            result.more || moreLink.getAttribute('data-sbs-more-fallback') || '#sbs-shop'
          );
        }
        // Filter by the actual answer key so "Not sure yet|…" matches work;
        // copy still falls back to map.default when no specific entry exists.
        filterProducts(key);
      };

      quiz.querySelectorAll('[data-sbs-quiz-opt]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.getAttribute('data-sbs-quiz-group');
          const value = btn.getAttribute('data-sbs-quiz-opt') || '';
          if (!group) return;
          quiz.querySelectorAll(`[data-sbs-quiz-group="${group}"]`).forEach((b) => {
            b.classList.toggle('is-active', b === btn);
          });
          answers[group] = value;
          update();
        });
      });

      update();
    });
  }

  function boot() {
    bindQuiz();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
